import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

class BaseFacturaService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public create(data) {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + this.urlKeyword, data)
      .pipe(map(response => response || {}));
  }

  public getActive(limit = 10, skip = 0, filters = {}, conds = {}, ordering = {}): Observable<any> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('skip', skip.toString());

    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'invoiceList', this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public get(id: number | string): Observable<any> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + id)
      .pipe(map(response => {
        const projectData: JSON = response || {};
        ['data_factura', 'data_cobrament'].forEach(key => {
          if (projectData[key]) {
            try {
              const d = new Date(projectData[key]);
              projectData[key] = d.toISOString().slice(0, 10);
            } catch (e) {
              console.log('Received invalid date for ' + key);
              projectData[key] = '';
            }
          }
        });
      return projectData;
    }));
  }

  public updateData(id: number, newData: any): Observable<any> {
    return this.authHttp.put<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + id, newData)
      .pipe(map(response => response || {}));
  }

  constructor(
    protected authHttp: HttpClient,
    protected urlKeyword,
    private validFilters,
    private validOrdering,
    private dateFields
  ) {}
}

@Injectable()
export class FacturaService extends BaseFacturaService {
  constructor(authHttp: HttpClient) {
    super(authHttp, 'project', [
      'dataCode', 'dataTematica', 'dataTecnic', 'dataEmpresa', 'dataClient', 'dataTitol', 'dataTitolOf',
      'stateActive', 'stateFinished', 'stateClosed', 'statePaused', 'stateCancelled'
    ], [
      'codi', 'tematica3', 'qui_col·labora', 'data_aprovacio', 'data_finalitzacio', 'pressupost_propi_proj', 'durada_mesos'
    ], [
      'data_aprovacio', 'data_finalitzacio', 'data_pagament_garantia', 'data_signatura'
    ]);
  }
}
